import { Box, type IColumn, Typography } from 'shared/ui'
import { type ReviewRow } from 'entities/Review'
import { RatingStars } from 'pages/reviews/pages/all/ui/RatingStars/RatingStars'

export const columns: IColumn<ReviewRow>[] = [
  {
    field: 'name',
    name: 'Name',
    isDisabledChangeVisible: true,
    isSortable: true,
    width: '100%',
    minWidth: 230,
    renderRowCell: ({ name }) => (
      <Typography variant='body-md-regular' ariaLabel='ReviewName' ellipsis>
        {name}
      </Typography>
    ),
  },
  {
    field: 'rating',
    name: 'Rating',
    minWidth: 195,
    renderRowCell: ({ rating, happy_count, unhappy_count }) => (
      <Box display={'flex'} alignItems={'center'} gap={'8px'}>
        {!!rating && (
          <Typography variant='body-md-regular' ariaLabel='ReviewRating'>
            {rating}
          </Typography>
        )}
        <RatingStars rating={rating} />
        <Typography variant='body-md-regular' ariaLabel='ReviewRatingCount' color='tertiary'>
          ({happy_count + unhappy_count})
        </Typography>
      </Box>
    ),
  },
  {
    field: 'happy_count',
    name: 'Stars (4-5)',
    minWidth: 100,
    renderRowCell: ({ happy_count }) => (
      <Typography variant='body-md-regular' ariaLabel='ReviewStarsHigh'>
        {happy_count}
      </Typography>
    ),
  },
  {
    field: 'unhappy_count',
    name: 'Stars (1-3)',
    minWidth: 100,
    renderRowCell: ({ unhappy_count }) => (
      <Typography variant='body-md-regular' ariaLabel='ReviewStarsLow'>
        {unhappy_count}
      </Typography>
    ),
  },
  {
    field: 'review_page_clicks',
    name: 'Review page clicks',
    minWidth: 140,
    renderRowCell: () => (
      <Typography variant='body-md-regular' ariaLabel='ReviewPageClicks'>
        0
      </Typography>
    ),
  },
  {
    field: 'short_url',
    name: 'Review page link',
    renderRowCell: ({ short_url }) => (
      <a href={short_url} target={'_blank'} rel='noreferrer' className={'noTextDecoration'}>
        <Typography variant={'body-md-regular'} link ariaLabel={'ReviewPageLink'}>
          {short_url}
        </Typography>
      </a>
    ),
  },
]
